import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/contratos/fiscais/listar/form_edit'
import Head from '../../../../../components/head'


function EditarFiscalContratoScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Fiscal de Contrato" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarFiscalContratoScreen;